import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';
import ImportAuthFilesView from 'modules/authorizations/import/importAuthFiles.container';
import ImportAuthUpdatesView from 'modules/authorizations/import/importAuthUpdates.container';
import ImportHhgWeightsView from 'modules/authorizations/import/importHhgWeights.container';

export const IMPORT_TOOL_ROUTE = '/importTool';
export const IMPORT_TOOL_TITLE = 'Import Tool';

// Any one of these opens the import tool. Tools without a permission of their own are available to everyone who can open it.
export const IMPORT_TOOL_PERMISSIONS = [Permissions.File.Pending.Import, Permissions.File.Import];

// Each tool gets a tile on the import tool page (with its description), its own route under it, and a breadcrumb in the
// AppBar. A tool with a permission is only shown to, and can only be opened by, users who have it. Icons must be registered
// in utilities/iconLoader.
export const IMPORT_TOOLS = [
  {
    title: 'Pending Authorizations',
    route: `${IMPORT_TOOL_ROUTE}/pendingAuthorizations`,
    icon: ['fas', 'user-plus'],
    permission: Permissions.File.Pending.Import,
    description: 'Create pending authorizations in bulk and make them available for assignment. Map the import file\'s columns to authorization '
      + 'fields, and optionally advance each new authorization to an intake record with its '
      + 'relocation counselor.',
    component: ImportAuthFilesView,
  },
  {
    title: 'Authorization Updates',
    route: `${IMPORT_TOOL_ROUTE}/authorizationUpdates`,
    icon: ['fas', 'user-pen'],
    permission: Permissions.File.Import,
    description: 'Update existing authorizations in bulk, matching each row by file number. Each mapped field, such as team '
      + 'members, division, policy, or client custom fields, takes its value from a column or from an override applied to '
      + 'every row.',
    component: ImportAuthUpdatesView,
  },
  {
    title: 'HHG Weight Actuals',
    route: `${IMPORT_TOOL_ROUTE}/hhgWeightActuals`,
    icon: ['fas', 'weight-scale'],
    description: 'Record actual land, air, and sea weights on existing HHG estimates in bulk. Each row is matched to its '
      + 'authorization by file number and to the estimate by its ID. Blank weights are left as they are, and estimated '
      + 'weights are never changed.',
    component: ImportHhgWeightsView,
  },
];

export const hasImportToolAccess = () => IMPORT_TOOL_PERMISSIONS.some(hasPermission);

export const getAvailableImportTools = () => IMPORT_TOOLS.filter(tool => !tool.permission || hasPermission(tool.permission));

export const IMPORT_TOOL_BREADCRUMB_LINKS = [
  { link: IMPORT_TOOL_ROUTE, name: IMPORT_TOOL_TITLE },
  ...IMPORT_TOOLS.map(tool => ({ link: tool.route, name: tool.title })),
];
